<template>
  <div v-if="showBack">
    <img :src="imageMap.backButton" alt="" class="backButton" @click="goBack">
  </div>
</template>

<script>
  import imageMap from '../../image-map.js';

  export default {
    data() {
      return { imageMap };
    },

    computed : {
      showBack() {
        const ptid = JSON.parse( localStorage.getItem( 'ptid' ) );

        return ptid === 'dxys';
      }
    },

    methods : {
      goBack() {
        history.back();
      }
    }
  };
</script>

<style scoped lang="scss">
  @import "./page-header.scss";
</style>



// WEBPACK FOOTER //
// src/projects/virusTrip/pages/home/page-header.vue